/* eslint-disable */
// @ts-nocheck
import React from "react";
import { TabList, Tab } from "@carbon/react";
import Badge from "../../components/badge/Badge";
import { ReactComponent as CheckIcon } from "../../assets/icons/check.svg";

interface IProps {
  TABS_LIST: {
    tabName: string;
    classname: string;
    showCheckmark: boolean | string;
  }[];
  fileName: string;
  activation?: "manual" | "automatic";
  ariaLabel?: string;
  className?: string;
  showCheckmark?: boolean;
  steps?: number;
  disabled?: boolean;
}

const BulkUploadTabList = ({
  ariaLabel,
  activation = "automatic",
  TABS_LIST,
  fileName,
  className,
  steps,
  showCheckmark,
  disabled = true,
}: IProps) => {
  return (
    <TabList
      aria-label={ariaLabel}
      activation={activation}
      className={className}
    >
      {TABS_LIST.map((tab, idx) => {
        return (
          <Tab
            data-cy={`${tab.tabName.replaceAll(" ", "")}-tab`}
            disabled={disabled}
            className={tab.classname}
          >
            {/* {showCheckmark && steps === idx + 1 ? ( */}
            {tab.showCheckmark ? <Badge /> : <Badge badgeCounter={idx + 1} />}
            {tab.tabName}
          </Tab>
        );
      })}
    </TabList>
  );
};
export default BulkUploadTabList;
